module.exports = __webpack_public_path__ + "static/media/zip-editor.8636e2b5.png";